import React from "react";
import { View, Image } from "react-native";
import Text from "./customText";

class AvailableTime extends React.Component {
  render() {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "white",
          left: 0,
          right: 0,
          //top: 0,
          bottom: 0,
          position: "fixed",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Image
          style={{ width: 200, height: 200 }}
          resizeMode="contain"
          source={require("../assets/images/downtime.png")}
        />
        <Text
          style={{
            textAlign: "center",
            fontSize: 16,
            paddingHorizontal: 15,
            color: "black",
            fontFamily: "Mulish"
          }}
        >
          {this.props.maintainanceText}
        </Text>
      </View>
    );
  }
}
export default AvailableTime;
